module.exports = __webpack_public_path__ + "img/Resources_YD.e2d52879.webp";